import { render, staticRenderFns } from "./Details2Product.vue?vue&type=template&id=241c901b&scoped=true"
import script from "./Details2Product.vue?vue&type=script&lang=js"
export * from "./Details2Product.vue?vue&type=script&lang=js"
import style0 from "./Details2Product.vue?vue&type=style&index=0&id=241c901b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c901b",
  null
  
)

export default component.exports